import { AdminProfile } from '@/features/admin-profile/components/AdminProfile'
import Dashboard from '@/features/dashboard/components/Dashboard'
import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@/app/stores/auth'
import { Card, CardContent } from '@/shared/components/ui/Card'
import { useAcl } from '@/shared/hooks'

export const Route = createFileRoute('/_auth/')({
  component: DashboardRoute,
})

function DashboardRoute() {
  const { decodedToken } = useAuth();
  const user = useAcl().acl?.user_info; // Get user details from ACL context

  // DecodedToken.UserID is a string — parse to number for the avatar API
  const userID = decodedToken?.UserID ? parseInt(decodedToken.UserID, 10) : undefined
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">

        <div className="grid grid-cols-12 gap-6">
          {/* Search Sidebar */}
          <aside className="col-span-12 lg:col-span-3">
            <AdminProfile
              profileData={{
                ...(userID !== undefined && { userID }),
                name: user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}`.trim() : 'CTRAC Admin',
                email: user?.email ?? decodedToken?.EmailAddress ?? '',
                brand: user?.brand || 'N/A',
                country: user?.country || { id: '', name: 'N/A' },
                regions: user?.regions || [],
              }}
            />
          </aside>

          {/* Results Area */}
          <Card className="col-span-12 lg:col-span-9">
            <CardContent className="p-6">
                <Dashboard />
              </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}